import { Injector } from "@angular/core";
import { MedicinalProductListQueryNode } from "../../MedicinalProductListQueryNode";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { EntityEnum } from "../../../EntityEnum";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { TreeNodeProductsList } from "../../../Art57Node/ListEntity/TreeNodeProductsList";
import { AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { TreeNodeOrganisationList } from "../../../Art57Node/ListEntity/TreeNodeOrganisationList";

export class ValidationQueryNode extends MedicinalProductListQueryNode {
    constructor(injector: Injector) {
        super(injector, 'Validation');
            //Authorisation Product
            this.children.push(this.getAuthorisedProductValidation(injector));
            //Development Product
            this.children.push(this.getDevelopmentProductValidation(injector));
            //MAHs
            this.children.push(this.getMahsProductValidation(injector));
            //Sponsors
            this.children.push(this.getSponsorsProductValidation(injector));
    }

    private getAuthorisedProductValidation(injector: Injector): MedicinalProductsQueryNode {
            const createChidTemplateParams = {nodeTypeToCreateName: 'addAuthorisedProduct'};
            const queryFields =  new FieldDefinitionFields(injector).authorisedProductsFields;
            const queryConditions = new FieldDefinitionConditions(injector).authorisedProductsConditions;

            return new MedicinalProductsQueryNode(injector, [], 'Authorised Products', EntityEnum.authorisedProductValidation,
                queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.authorisedProductTreeNode, TreeNodeProductsList,
                AutoUploadEntityEnum.authorisedProduct, createChidTemplateParams); 
    }

    private getDevelopmentProductValidation(injector: Injector): MedicinalProductsQueryNode {
            const createChidTemplateParams = {nodeTypeToCreateName: 'addDevelopmentProduct'};
            const queryFields =  new FieldDefinitionFields(injector).developmentProductsFields;
            const queryConditions = new FieldDefinitionConditions(injector).developmentProductsConditions;

            return new MedicinalProductsQueryNode(injector, [], 'Development Products', EntityEnum.developmentProductValidation,
                queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.developmentProductTreeNode, TreeNodeProductsList,
                AutoUploadEntityEnum.developmentProduct, createChidTemplateParams); 
    }

    private getMahsProductValidation(injector: Injector): MedicinalProductsQueryNode {
            const createChidTemplateParams = {nodeTypeToCreateName: 'addOrganisation'};
            const queryFields =  new FieldDefinitionFields(injector).mahsFields;
            const queryConditions = new FieldDefinitionConditions(injector).mahsConditions;

            return new MedicinalProductsQueryNode(injector, [], 'MAHs', EntityEnum.mahvalidation,
                queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.mahsTreeNode, TreeNodeOrganisationList,
                AutoUploadEntityEnum.mah, createChidTemplateParams); 
    }

    private getSponsorsProductValidation(injector: Injector): MedicinalProductsQueryNode {
            const createChidTemplateParams = {nodeTypeToCreateName: 'addOrganisation'};
            const queryFields =  new FieldDefinitionFields(injector).sponsorFields;
            const queryConditions = new FieldDefinitionConditions(injector).sponsorConditions;

            return new MedicinalProductsQueryNode(injector, [], 'Sponsors', EntityEnum.sponsorvalidation,
                queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.sponsorTreeNode, TreeNodeOrganisationList,
                AutoUploadEntityEnum.sponsor, createChidTemplateParams); 
    }
}